// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"744":"f61693da","776":"f61693da"}[chunkId] + ".chunk.css";
};